import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiTableCell = {
  styleOverrides: {
    root: {
      borderBottom:
        'var(--TableCell-borderWidth, 1px) solid var(--mui-palette-TableCell-border)',
      padding: '10px 12px',
    },
    paddingCheckbox: { padding: '0 0 0 16px' },
  },
} satisfies Components<Theme>['MuiTableCell'];
